import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { download } from "@/lib/api";
import type { BookingRow } from "@/lib/types";
import { InvoiceDialog } from "./InvoiceDialog";

export function BookingActions({ selected, onDone }: { selected: BookingRow[]; onDone: () => void }) {
  const [invoicing, setInvoicing] = useState(false);
  const [exporting, setExporting] = useState(false);
  const singleClient = selected.length > 0 && new Set(selected.map((r) => r.clientName)).size === 1;
  const allOpen = selected.every((r) => !r.invoiced);
  const ids = selected.map((r) => r.id);

  async function exportPdf() {
    setExporting(true);
    try {
      await download("/api/reports", { entryIds: ids }, "Leistungsnachweis.pdf");
    } catch (e) {
      toast.error((e as Error).message);
    } finally {
      setExporting(false);
    }
  }

  const why = singleClient ? undefined : "Nur Buchungen eines Kunden auswählen";
  return (
    <>
      <Button variant="secondary" size="sm" disabled={!singleClient || exporting} title={why} onClick={exportPdf}>
        PDF-Leistungsnachweis
      </Button>
      <Button size="sm" disabled={!singleClient || !allOpen} title={why ?? (allOpen ? undefined : "Enthält bereits verrechnete Buchungen")}
        onClick={() => setInvoicing(true)}>
        Rechnung erstellen…
      </Button>
      <InvoiceDialog entryIds={ids} open={invoicing} onClose={() => setInvoicing(false)} onCreated={onDone} />
    </>
  );
}
